module.exports = __webpack_public_path__ + "img/try_demo_background_desktop.bcdc8d1f.png";